import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

export const AbilityContext = createContext();

// This function is created to support React's Context API
// https://reactjs.org/docs/context.html
// avoids having to pass props manually.
export const Can = createContextualCan(AbilityContext.Consumer);
